import fetch from 'node-fetch';
import store from '@/store';

import { EventBus } from './index';
import { getSSOLink } from '@/utils/auth';

async function makeApiRequest (path, method = 'GET', body = {}) {
  const params = {
    method: method,
    headers: {
      'content-Type': 'application/json',
      project: store.getters.getBrand,
      Authorization: `Bearer ${store.state.token}`
    },
    body: Object.keys(body).length !== 0 ? JSON.stringify(body) : undefined
  };
  return fetch(`${path}`, params)
    .then(response => {
      if (response.status === 401) {
        window.location.href = getSSOLink(window.location.origin, process.env.VUE_APP_SSO_CLIENT_ID);
        return null;
      }

      return response.json();
    })
    .then(async response => response).catch(err => {
      console.log('Error', err);
      return err;
    });
}

async function makeExternalRequest (url, method = 'GET', body = {}, headers = {}) {
  const params = {
    method: method,
    headers: { ...headers },
    body: body
  };
  return fetch(`${url}`, params)
    .then(async response => response).catch(err => {
      console.log('[ERROR] makeRequest:', err);
      return err;
    });
}

// eslint-disable-next-line import/prefer-default-export
export const requests = {
  methods: {
    async getAlphaOrderPaymentsToSync (orderUuid) {
      return makeApiRequest(`/api/alphaOrderPayments?orderUuid=${orderUuid}`, 'GET');
    },
    async syncAlphaOrderWithHoranet (orderUuid, paymentIntent) {
      return makeApiRequest('/api/alphaOrderPayments', 'POST', { orderUuid: orderUuid, paymentIntent });
    },
    async getAutocomplete (facet, query) {
      return makeApiRequest(`/api/autocomplete?facet=${facet}&query=${query}`, 'GET');
    },
    async getIresaOrders (customerIds, start = 0, limit = 10) {
      return makeApiRequest(`/api/iresa-orders?customer_id=${customerIds.join('&customer_id=')}&start=${start}&limit=${limit}`, 'GET');
    },
    async getOrders (start = 0, limit = 10, customerId, orderSrc, statusFilter, uuidsFilter) {
      let req = `/api/orders?start=${start}&limit=${limit}&customer_id=${customerId}&orderSrc=${orderSrc}`;
      if (uuidsFilter) {
        req = `${req}&uuidsFilter=${uuidsFilter}`;
      }
      if (statusFilter) {
        req = `${req}&statusFilter=${statusFilter}`;
      }
      return makeApiRequest(req, 'GET');
    },
    async getCustomer (uuid) {
      return makeApiRequest(`/api/customer?uuid=${uuid}`, 'GET');
    },
    async getCustomers (iresa_id) {
      return makeApiRequest(`/api/customers?iresa_id=${iresa_id}`, 'GET');
    },
    async saveCustomerRequest (customer) {
      return makeApiRequest('/api/customer', 'PUT', customer);
    },
    addIresaIdToCustomerRequest (body) {
      return makeApiRequest('/api/addIresaId', 'PUT', body);
    },
    removeIresaIdToCustomerRequest (body) {
      return makeApiRequest('/api/removeIresaId', 'PUT', body);
    },
    async exportCustomerRequest (customerId) {
      return makeApiRequest(`/api/export?customerId=${customerId}`, 'GET');
    },
    async searchIresaContexts (args) {
      let url = '/api/searchIresa?';

      Object.entries(args).map(([key, value]) => {
        if (value) {
          url += `${key}=${value}&`;
        }
      });
      url = url.slice(0, -1);
      return makeApiRequest(`${url}`, 'GET');
    },
    async createCustomer (body) {
      return makeApiRequest('/api/customer', 'POST', body);
    },
    async addContactoCustomerRequest (contentUuid, contactUuid) {
      const response = await makeApiRequest('/api/addContact', 'PUT', { uuid: contentUuid, contact_uuid: contactUuid });
      if (response.data.success) {
        this.content.contacts = response.data.customer.contacts;
        const notification = {
          message: 'Contact added!',
          type: 'success'
        };
        EventBus.$emit('show-notifications', [notification]);
      } else {
        const notification = {
          message: response.data.message,
          type: 'error'
        };
        EventBus.$emit('show-notifications', [notification]);
      }
    },
    async generateReferralCode (code) {
      return makeApiRequest('/api/referral', 'POST', code);
    },
    async addVisibleOrder (booking, customer_uuid) {
      return makeApiRequest('/api/viewers', 'POST', { booking: booking, customer_uuid: customer_uuid });
    },
    async regenerateKeziaId (costumer_uuid) {
      return makeApiRequest('/api/regenerate-kezia-id', 'PUT', { costumer_uuid: costumer_uuid });
    },
    async shareQRcode (email, qrCode, language) {
      return makeApiRequest(`/api/share-qrcode?email=${email}&qrcode=${qrCode}&language=${language}`, 'GET');
    },
    async getAlphaWorkspaces () {
      return makeApiRequest('/api/alpha-workspaces', 'GET');
    },
    async getLimitedProducts (workspace) {
      return makeApiRequest(`/api/limitedProducts?workspace=${workspace}`, 'GET');
    },
    async getAlphaProducts (workspace) {
      return makeApiRequest(`/api/alphaProducts?workspace=${workspace}`, 'GET');
    },
    async updateCustomerAllowedProduct (customer_uuid, allowed_products, workspace) {
      return makeApiRequest('/api/allowedProduct', 'POST', { customer_uuid, allowed_products, workspace });
    },
    async updateOrder (body) {
      return makeApiRequest('/api/alpha-order-items', 'POST', body);
    },
    async anonymiseCustomerRequest (costumer_uuid) {
      return makeApiRequest('/api/anonymise-customer', 'PUT', { costumer_uuid: costumer_uuid });
    },
    async anonymiseCustomerFederationRequest (customer_uuid) {
      return makeApiRequest('/api/anonymise-customer-federation', 'PUT', { customer_uuid: customer_uuid });
    },
    async resetCustomerPasswordRequest (customer_email, poolName, channel, selectedWorkspace) {
      const baseUrl = poolName === 'labalaguere' ? process.env.VUE_APP_LABALAGUERE_DOMAIN : process.env.VUE_APP_UCPA_DOMAIN;

      const redirect_uri = `${baseUrl}/af/sso/authorize`;

      const params = {
        context: poolName,
        email: customer_email,
        channel: channel,
        redirect_uri: redirect_uri
      };

      if (selectedWorkspace && poolName !== 'labalaguere' && selectedWorkspace.code !== 'speedboat') {
        const payload = {
          returnUrl: `${process.env.VUE_APP_UCPA_DOMAIN}/${selectedWorkspace.sitePreRoute}/${selectedWorkspace.siteUrl}`,
          origin: 'crm-dashboard',
          ts: Date.now()
        };

        params.context = 'alpha';
        params.state = btoa(JSON.stringify(payload));
      }

      console.log('[INFO] Request Params: ', params);

      const urlSearchParams = new URLSearchParams(params);

      return fetch(`${process.env.VUE_APP_SSO_AMPLIFY_URL}/idp/reset-password?${urlSearchParams.toString()}`).then(res => {
        if (res.status !== 200) {
          return { success: false };
        }

        return res.json();
      }).catch(err => {
        console.log('[ERROR] Failed to request a password reset -> ', err);
        return { success: false };
      });
    },
    async updateCustomerWorkspace (customer_uuids, deselectedUuids, workspace) {
      return makeApiRequest('/api/customerWorkspace', 'POST', { customer_uuids: customer_uuids, workspace: workspace, deselectedUuids: deselectedUuids });
    },
    async impersonateMode (customer, collaborator, workspace) {
      return makeApiRequest('/api/impersonateMode', 'POST', { customer, collaborator, workspace });
    },
    async getCustomerAlphaOrderStatus (uuid, workspaces) {
      return makeApiRequest('/api/alphaOrderStatus', 'PUT', { uuid, workspaces });
    },
    async changeOrderStatus (orderUuid, blocked) {
      return makeApiRequest('/api/alphaOrderStatus', 'POST', { orderUuid, blocked });
    },
    async geCustomerVersions (uuid) {
      return makeApiRequest(`/api/customerVersions?uuid=${uuid}`, 'GET');
    },
    async geCustomerVersionComparison (uuid, versionId, compareVersionId) {
      return makeApiRequest(`/api/customerVersionComparison?uuid=${uuid}&versionId=${versionId}${compareVersionId ? `&compareVersionId=${compareVersionId}` : ''}`, 'GET');
    },
    async setCustomerIresaContextActive (contextId, iresaId, customerUuid) {
      return makeApiRequest('/api/customerContext', 'PUT', { contextId, iresaId, customerUuid });
    },
    async changeContractStockBalance (customerUuid, contractNumber, oldStock, newStock, collaboratorUuid, observation) {
      return makeApiRequest('/api/contracts', 'POST', { customerUuid, contractNumber, oldStock, newStock, collaboratorUuid, observation });
    },
    async getContractHistory (customerUuid, contractNumber) {
      return makeApiRequest(`/api/contracts?customerUuid=${customerUuid}&contractNumber=${contractNumber}`, 'GET');
    },
    async changeContractHistoryObservation ({ contractNumber, timestamp, newObservation }) {
      return makeApiRequest('/api/contracts', 'PUT', { contractNumber, timestamp, newObservation });
    },
    async getContractSessions (contractNumber, workspace, startDate, endDate) {
      return makeApiRequest(`/api/contractSessions?contractNumber=${contractNumber}&workspace=${workspace}&startDate=${startDate}&endDate=${endDate}`, 'GET');
    },
    async enableCustomerDigitalAccount (customerUuid) {
      return makeApiRequest('/api/enable-digital-account', 'POST', { uuid: customerUuid });
    },
    async updateContractEndValidity (customerUuid, contractNumber, newEndDate, collaboratorUuid) {
      return makeApiRequest('/api/contractsValidity', 'POST', { customerUuid, contractNumber, newEndDate, collaboratorUuid });
    },
    async getContractValidityHistory (contractNumber) {
      return makeApiRequest(`/api/contractsValidity?contractNumber=${contractNumber}`, 'GET');
    },
    async getDeactivatedPartners () {
      return makeApiRequest('/api/deactivated-partners', 'GET');
    }
  }
};
